
import './NoAuthTable.scss';

export default function NoAuthTable({ users, onAuthorize, title = "Employee Users in Use by Great Plains", searchTerm = ''}) {
  function handleAuthorize(user) {
    if (onAuthorize) {
      onAuthorize(user);
    }
  }

  const term = (searchTerm || '').toLowerCase();

    const filteredUsers = (users ?? []).filter((u) => {
      if (!term) return true;
      return (
        (u.full_name ?? '').toLowerCase().includes(term) ||
        (u.username ?? '').toLowerCase().includes(term)
      );
    });
    const isMobile = window.innerWidth <= 550;


  return (
    <section className="authorize-users">
      <div className="authorize-users-table-wrapper">
        <div className="NoAuth-header">
          <h2>{title}</h2>
        </div>
        <table className="authorize-users-table">
          <thead>
            <tr>
              <th className="col-user">Name</th>
              <th className="col-email">Email</th>
              <th className="col-authorize">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers?.map(user => (
              <tr key={user.id || user.username}>
                {/* Name */}
                <td className="col-user">
                  <span className="user-name">{user.full_name}</span>
                  <span className="user-email">{user.username}</span>
                </td>
                {/* Email */}
                <td className="col-email">
                  <span className="user-email">{user.username}</span>
                </td>
                {/* Authorize Button */}
                <td className="col-authorize">
                  <button
                    className="authorize-btn"
                    disabled={user.authorized}
                    onClick={() => handleAuthorize(user)}
                  >
                    {user.authorized ? 'Authorized' : 'Authorize'}
                  </button>
                </td>
              </tr>
            ))}
            {filteredUsers.length === 0 && (
              <tr>
                <td colSpan={isMobile ? 2 : 3} >No employees found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
